const EmptyDealsMessage =
  "It looks like you've redeemed all of the available deals or there are none currently in stock. Please check back soon for more MyWEM deals!";

export { EmptyDealsMessage };
